var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10869_102695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.87484 21L2.99609 19.125H4.87484V21ZM19.1248 21L21.0036 19.125H19.1248V21Z",
    fill: "#A3313A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1252 4.87516H16.1289V1.87891L19.1252 4.87516Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 1.875H5.47125C5.31311 1.875 5.16146 1.93782 5.04964 2.04964C4.93782 2.16146 4.875 2.31311 4.875 2.47125V21.5963C4.875 21.7547 4.9377 21.9068 5.04941 22.0192C5.16112 22.1316 5.31277 22.1953 5.47125 22.1962H18.5287C18.6088 22.1958 18.688 22.1793 18.7616 22.1478C18.8352 22.1162 18.9018 22.0703 18.9573 22.0126C19.0129 21.9549 19.0564 21.8867 19.0852 21.812C19.114 21.7373 19.1275 21.6575 19.125 21.5775V4.875H16.125V1.875Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.375 12.375H20.625C20.7245 12.375 20.8198 12.4145 20.8902 12.4848C20.9605 12.5552 21 12.6505 21 12.75V19.125H3V12.75C3 12.6505 3.03951 12.5552 3.10984 12.4848C3.18016 12.4145 3.27554 12.375 3.375 12.375Z",
    fill: "#C84D52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.875 16.1718V17.2481H8.125V14.1806H9.325C9.62764 14.1593 9.92654 14.2576 10.1575 14.4543C10.2572 14.5509 10.3346 14.668 10.3845 14.7975C10.4344 14.927 10.4554 15.0659 10.4463 15.2043C10.4482 15.3813 10.4043 15.5557 10.3188 15.7106C10.2309 15.8622 10.1005 15.9848 9.94375 16.0631C9.75318 16.154 9.54353 16.1977 9.3325 16.1906L8.875 16.1718ZM9.7 15.1856C9.7 14.9156 9.55 14.7806 9.25 14.7806H8.875V15.5793H9.25C9.55 15.5793 9.7 15.4481 9.7 15.1856ZM13.3825 16.4981C13.2543 16.7294 13.0614 16.9184 12.8275 17.0418C12.5646 17.1772 12.2719 17.2443 11.9763 17.2368H10.8175V14.1806H11.9763C12.2715 14.1728 12.564 14.2385 12.8275 14.3718C13.0621 14.4927 13.2553 14.6807 13.3825 14.9118C13.5141 15.1571 13.58 15.4323 13.5738 15.7106C13.5771 15.985 13.5113 16.2558 13.3825 16.4981ZM12.5838 16.3443C12.7389 16.1645 12.8243 15.935 12.8243 15.6975C12.8243 15.46 12.7389 15.2304 12.5838 15.0506C12.3976 14.8884 12.1551 14.8062 11.9088 14.8218H11.56V16.5731H11.9088C12.1535 16.5918 12.3959 16.5137 12.5838 16.3556V16.3443ZM15.9963 14.1806V14.7731H14.7362V15.4443H15.7075V16.0068H14.7362V17.2481H13.9862V14.1806H15.9963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.338 3.94897C12.3657 4.20889 12.3401 4.47172 12.263 4.72147C11.9293 5.87272 10.8118 10.069 9.96801 10.6652C8.76426 11.5202 8.13801 10.549 8.77926 9.85897C9.42051 9.16897 13.2905 8.25022 14.5243 8.25022C16.1293 8.25022 15.923 9.67147 15.0118 9.58522C13.9843 9.48772 11.4155 7.73647 11.2618 4.40647C11.1943 3.22147 12.2218 3.00022 12.338 3.94897Z",
    stroke: "#C84D52",
    strokeWidth: 0.046875,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10869_102695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordFile);
export default __webpack_public_path__ + "static/media/Word File.6a87ad83be59d03d549bf2b956f05fe8.svg";
export { ForwardRef as ReactComponent };